import React from 'react';

import { Space } from 'antd';

import EmailEditorFontSetting from './EmailEditorFontSetting';

const EmailEditorGreetingSettings = () => {
  return (
    <Space direction='horizontal' size={0}>
      <EmailEditorFontSetting />
    </Space>
  );
};

export default EmailEditorGreetingSettings;
